var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "table-responsive mb-0" }, [
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", { staticClass: "sticky-top bg-white text-center" }, [
            _c(
              "th",
              {
                staticClass: "align-middle text-nowrap",
                attrs: { scope: "col" }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(_vm.T.wordsID) + " "),
                    _c("omegaup-common-sort-controls", {
                      attrs: {
                        column: "problem_id",
                        "sort-order": _vm.sortOrder,
                        "column-name": _vm.columnName
                      },
                      on: {
                        "apply-filter": function(columnName, sortOrder) {
                          return _vm.$emit(
                            "apply-filter",
                            columnName,
                            sortOrder
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "th",
              {
                staticClass: "align-middle text-nowrap",
                attrs: { scope: "col" }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.T.wordsTitle))]),
                _c(
                  "span",
                  {
                    staticClass:
                      "badge custom-badge custom-badge-quality mr-1 ml-1 p-2"
                  },
                  [_vm._v(_vm._s(_vm.T.tagSourceLevel))]
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "badge custom-badge custom-badge-owner mr-1 p-2"
                  },
                  [_vm._v(_vm._s(_vm.T.tagSourceOwner))]
                ),
                _c(
                  "span",
                  { staticClass: "badge custom-badge custom-badge-voted p-2" },
                  [_vm._v(_vm._s(_vm.T.tagSourceVoted))]
                ),
                _c("omegaup-common-sort-controls", {
                  attrs: {
                    column: "title",
                    "column-type": _vm.omegaup.ColumnType.String,
                    "sort-order": _vm.sortOrder,
                    "column-name": _vm.columnName
                  },
                  on: {
                    "apply-filter": function(columnName, sortOrder) {
                      return _vm.$emit("apply-filter", columnName, sortOrder)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "th",
              {
                staticClass: "align-middle text-nowrap",
                attrs: { scope: "col" }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(_vm.T.wordsQuality) + " "),
                    _c("omegaup-common-sort-controls", {
                      attrs: {
                        column: "quality",
                        "sort-order": _vm.sortOrder,
                        "column-name": _vm.columnName
                      },
                      on: {
                        "apply-filter": function(columnName, sortOrder) {
                          return _vm.$emit(
                            "apply-filter",
                            columnName,
                            sortOrder
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "th",
              {
                staticClass: "align-middle text-nowrap",
                attrs: { scope: "col" }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(_vm.T.wordsDifficulty) + " "),
                    _c("omegaup-common-sort-controls", {
                      attrs: {
                        column: "difficulty",
                        "sort-order": _vm.sortOrder,
                        "column-name": _vm.columnName
                      },
                      on: {
                        "apply-filter": function(columnName, sortOrder) {
                          return _vm.$emit(
                            "apply-filter",
                            columnName,
                            sortOrder
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "th",
              {
                staticClass: "align-middle text-nowrap",
                attrs: { scope: "col" }
              },
              [
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(_vm.T.wordsRatio) + " "),
                    _c("omegaup-common-sort-controls", {
                      attrs: {
                        column: "ratio",
                        "sort-order": _vm.sortOrder,
                        "column-name": _vm.columnName
                      },
                      on: {
                        "apply-filter": function(columnName, sortOrder) {
                          return _vm.$emit(
                            "apply-filter",
                            columnName,
                            sortOrder
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm.loggedIn
              ? _c(
                  "th",
                  {
                    staticClass: "align-middle text-nowrap",
                    attrs: { scope: "col" }
                  },
                  [
                    _c(
                      "span",
                      [
                        _vm._v(_vm._s(_vm.T.wordsMyScore) + " "),
                        _c("omegaup-common-sort-controls", {
                          attrs: {
                            column: "score",
                            "sort-order": _vm.sortOrder,
                            "column-name": _vm.columnName
                          },
                          on: {
                            "apply-filter": function(columnName, sortOrder) {
                              return _vm.$emit(
                                "apply-filter",
                                columnName,
                                sortOrder
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "th",
              {
                staticClass: "align-middle text-nowrap",
                attrs: { scope: "col" }
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          href: _vm.UserRankingFeatureGuideURL,
                          rel: "tooltip",
                          title: _vm.T.wordsPointsForRank,
                          "data-original-title": _vm.T.wordsPointsForRankTooltip
                        }
                      },
                      [_c("img", { attrs: { src: "/media/question.png" } })]
                    ),
                    _c("omegaup-common-sort-controls", {
                      attrs: {
                        column: "points",
                        "sort-order": _vm.sortOrder,
                        "column-name": _vm.columnName
                      },
                      on: {
                        "apply-filter": function(columnName, sortOrder) {
                          return _vm.$emit(
                            "apply-filter",
                            columnName,
                            sortOrder
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ]),
        _c(
          "tbody",
          { attrs: { "data-problems": "" } },
          _vm._l(_vm.problems, function(problem) {
            return _c("tr", { key: problem.problem_id }, [
              _c("td", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(problem.problem_id))
              ]),
              _c(
                "td",
                { staticClass: "align-middle" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        href: "/arena/problem/" + problem.alias + "/",
                        "data-problem-title-list": ""
                      }
                    },
                    [_vm._v(_vm._s(problem.title))]
                  ),
                  problem.qualitySeal || problem.visibility === 3
                    ? _c("font-awesome-icon", {
                        attrs: {
                          title: _vm.T.wordsHighQualityProblem,
                          icon: ["fas", "medal"],
                          color: "gold"
                        }
                      })
                    : problem.visibility === -1
                    ? _c("font-awesome-icon", {
                        attrs: {
                          title: _vm.T.wordsWarningProblem,
                          icon: ["fas", "exclamation-triangle"]
                        }
                      })
                    : problem.visibility <= -3
                    ? _c("font-awesome-icon", {
                        attrs: {
                          title: _vm.T.wordsBannedProblem,
                          icon: ["fas", "ban"]
                        }
                      })
                    : problem.visibility === 0
                    ? _c("font-awesome-icon", {
                        attrs: {
                          title: _vm.T.wordsPrivate,
                          icon: ["fas", "eye-slash"]
                        }
                      })
                    : _vm._e(),
                  _vm._l(problem.tags, function(tag) {
                    return _c(
                      "a",
                      {
                        key: tag.name,
                        class:
                          "badge custom-badge custom-badge-" +
                          (tag.source.includes("quality")
                            ? "owner"
                            : tag.source) +
                          " " +
                          (tag.name.includes("problemLevel")
                            ? "custom-badge-quality"
                            : "") +
                          " m-1 p-2",
                        attrs: {
                          href: _vm.hrefForProblemTag(
                            _vm.selectedTags,
                            tag.name
                          )
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            Object.prototype.hasOwnProperty.call(
                              _vm.T,
                              tag.name
                            )
                              ? _vm.T[tag.name]
                              : tag.name
                          )
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              problem.quality !== null
                ? _c(
                    "td",
                    { staticClass: "text-center align-middle tooltip_column" },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value:
                                "" +
                                _vm.ui.formatString(_vm.T.wordsOutOf4, {
                                  Score: problem.quality.toFixed(1)
                                }),
                              expression:
                                "\n                `${ui.formatString(T.wordsOutOf4, {\n                  Score: problem.quality.toFixed(1),\n                })}`\n              "
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.QUALITY_TAGS[Math.round(problem.quality)]
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                : _c("td", { staticClass: "text-right align-middle" }, [
                    _vm._v("—")
                  ]),
              problem.difficulty !== null
                ? _c("td", { staticClass: "text-center align-middle" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value:
                              "" +
                              _vm.ui.formatString(_vm.T.wordsOutOf4, {
                                Score: problem.difficulty.toFixed(1)
                              }),
                            expression:
                              "\n                `${ui.formatString(T.wordsOutOf4, {\n                  Score: problem.difficulty.toFixed(1),\n                })}`\n              "
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.DIFFICULTY_TAGS[
                                Math.round(problem.difficulty)
                              ]
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                : _c("td", { staticClass: "text-center align-middle" }, [
                    _vm._v("—")
                  ]),
              _c("td", { staticClass: "text-right align-middle" }, [
                _vm._v(" " + _vm._s((100.0 * problem.ratio).toFixed(2)) + "%"),
                _c("br"),
                _vm._v(
                  "(" +
                    _vm._s(problem.accepted) +
                    "/" +
                    _vm._s(problem.submissions) +
                    ") "
                )
              ]),
              _vm.loggedIn
                ? _c("td", { staticClass: "text-right align-middle" }, [
                    _vm._v(" " + _vm._s(problem.score.toFixed(2)) + " ")
                  ])
                : _vm._e(),
              _c("td", { staticClass: "text-right align-middle" }, [
                _vm._v(" " + _vm._s(problem.points.toFixed(2)) + " ")
              ])
            ])
          }),
          0
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "card-footer" },
      [
        _c("omegaup-common-paginator", {
          attrs: { "pager-items": _vm.pagerItems }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }